import appConfig from 'constants/appConfig';
import { localStorageKeys } from 'constants/localStorageKeys';

const authService = {
  getAccessToken() {
    return localStorage.getItem(localStorageKeys.accessToken);
  },

  setAccessToken(token: string) {
    return localStorage.setItem(localStorageKeys.accessToken, token);
  },

  getRefreshToken() {
    return localStorage.getItem(localStorageKeys.refreshToken);
  },

  setRefreshToken(token: string) {
    return localStorage.setItem(localStorageKeys.refreshToken, token);
  },

  clearAuthTokens() {
    localStorage.removeItem(localStorageKeys.accessToken);
    localStorage.removeItem(localStorageKeys.refreshToken);
    localStorage.removeItem(localStorageKeys.expiredIn);
  },

  setExpiredIn(duration: string) {
    return localStorage.setItem(localStorageKeys.expiredIn, String(Date.now() + Number(duration)));
  },

  getExpiredIn() {
    return localStorage.getItem(localStorageKeys.expiredIn);
  },
};

if (appConfig.isDev || appConfig.isStaging || appConfig.isQa) {
  (global as any).printToken = () => {
    const token = authService.getAccessToken();
    console.warn(JSON.stringify({ authorization: token ?? 'NOT DEFINED' }));
  };
}

export default authService;
